import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useRoleIndexState,
  useRoleIndexActions
} from './RoleIndexContext';
import RoleIndexLoader from './RoleIndexLoader';
import RoleModal from './RoleModal';

import styles from './Index.module.scss';

const RoleIndexContent = () => {
  const state = useRoleIndexState();
  const { openRoleModal } = useRoleIndexActions();

  const goToRole = (role) => {
    location.assign(`/roles/${role.id}`);
  };

  return (
    <>
      <section className={styles.section}>
        <Button
          variant="primary"
          onClick={(e) => {
            e.preventDefault();
            openRoleModal();
          }}
        >
          Create Role
        </Button>
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Roles
        </h2>
        {state?.roles?.length ? (
          <table id={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>Group Id</th>
                <th className={styles.th}>Role Name</th>
              </tr>
            </thead>
            <tbody>
              {state?.roles?.map(role => {
                return (
                  <tr key={role.id} className={styles.tr}>
                    <td className={styles.td}>{role.groupId}</td>
                    <td className={styles.td}>{role.roleName}</td>
                    <td className={styles.td}>
                      <Button
                        variant="primary"
                        onClick={() => goToRole(role)}
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No roles.</p>
        )}
      </section>
    </>
  );
};

const Index = () => {
  return (
    <>
      <RoleIndexLoader />
      <RoleIndexContent />
      <RoleModal />
    </>
  );
};

export default Index;
